const featuredProjectsList = [
  {
    id: '01',
    title: 'Homerooom',
    description: 'An all-in-one mobile app solution for online learning. Made with React Native and Firebase',
    tags: ['React Native', 'Firebase'],
    thumbnail: 'homerooom-thumbnail.png',
    link: 'https://github.com/bernardadhitya/Homerooom',
  },
  {
    id: '02',
    title: 'riddlr',
    description: 'A mobile app that help teachers to generates Kahoot quiz based on article',
    tags: ['Flutter', 'BERT', 'T5', 'SQuAD', 'Jupyter Notebook', 'Firebase'],
    thumbnail: 'riddlr-thumbnail.png',
    link: 'https://github.com/bernardadhitya/riddlr',
  },
  {
    id: '03',
    title: 'sibi-sign-language-react-native',
    description: 'SIBI Sign Language Recogntion app using Keras, implemented in React Native',
    tags: ['React Native', 'Keras', 'Jupyter Notebook', 'Firebase'],
    thumbnail: 'sibi-sign-language-react-native-thumbnail.png',
    link: 'https://github.com/bernardadhitya/sibi-sign-language-react-native',
  },
  {
    id: '04',
    title: 'pasarvisual',
    description: 'A platform to connect creatives and business people, to help small business grow their business with creative digital media. Made with React Native and Firebase',
    tags: ['React Native', 'Firebase'],
    thumbnail: 'pasarvisual-thumbnail.jpg',
    link: 'https://github.com/bernardadhitya/pasarvisual',
  },
  {
    id: '05',
    title: 'intern-logbook-chatbot',
    description: 'Fill and view logbook from LINE. It also automatically updates local database to sync logbook faster, and autofill logbook',
    tags: ['Node.js', 'Github Actions', 'LINE API', 'Express.js'],
    thumbnail: 'intern-logbook-chatbot-thumbnail.png',
    link: 'https://github.com/bernardadhitya/intern-logbook-chatbot',
  }
];

export default featuredProjectsList;
